import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as s } from "react";
import { I as e } from "../../../../IconBase-CxZyIWw2.js";
const i = s(
  (a, r) => /* @__PURE__ */ o.jsx(
    e,
    {
      ref: r,
      ...a,
      image: (t) => /* @__PURE__ */ o.jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 16,
          height: 16,
          fill: "none",
          viewBox: "0 0 16 16",
          ...t,
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M8.951.691a1 1 0 0 0-1.902 0L5.702 4.837h-4.36a1 1 0 0 0-.587 1.809l3.527 2.562-1.347 4.146a1 1 0 0 0 1.539 1.118L8 11.91l3.527 2.562a1 1 0 0 0 1.539-1.118l-1.347-4.146 3.526-2.562a1 1 0 0 0-.587-1.81h-4.36z"
            }
          )
        }
      )
    }
  )
);
i.displayName = "StarIcon";
export {
  i as StarIcon,
  i as default
};
//# sourceMappingURL=index.js.map
